import React from 'react'
import t from 'prop-types'

import AccesoIndice from './acceso-indice'

function GrupoPortada ({ accesos, onAccion }) {
    return ( 
        <div className="grupoPortada">
            <div className="grupoAccesos">
                { accesos.map( (accion, index) => 
                    <AccesoIndice 
                        key={`acceso-indice-${index}`} 
                        accion={ accion } 
                        onAccion={ onAccion } />
                    ) 
                }
            </div>
        </div>
    )
}

GrupoPortada.propTypes = {
    accesos: t.arrayOf(t.shape({
        texto: t.string.isRequired,
        indice: t.string,
        pantalla: t.string,
        zona: t.string
    })).isRequired,
    onAccion: t.func.isRequired
}

export default GrupoPortada
